import { render, staticRenderFns } from "./cardeptspace.vue?vue&type=template&id=9fac7db4&"
import script from "./cardeptspace.vue?vue&type=script&lang=js&"
export * from "./cardeptspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports